import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useStartupRows from './useStartupRows';
import useMentorRows from './useMentorRows';
import useAdminRows from './useAdminRows';
import usePositionRows from './usePositionRows';

export const useNavRows = () => {
  const location = useLocation();
  const rolePath = location.pathname.split('/')[1];

  const [subMenu, setSubMenu] = useState('');
  const handleShowSubmenu = submenu => setSubMenu(prev => (prev === submenu ? null : submenu));

  const startupRows = useStartupRows(rolePath, subMenu, handleShowSubmenu);
  const adminRows = useAdminRows(rolePath, subMenu, handleShowSubmenu);
  const mentorRows = useMentorRows(rolePath);
  const positionRows = usePositionRows(rolePath);

  const navRows = useMemo(() => {
    if (rolePath === 'startup') return startupRows;
    if (rolePath === 'mentor') return mentorRows;
    if (rolePath === 'admin') return adminRows;
    if (rolePath === 'my-position') return positionRows;
    return [];
  }, [rolePath, startupRows, mentorRows, adminRows, positionRows]);

  return navRows;
};
